import { jsx } from '@emotion/react';
import _ from 'lodash';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';

import { ConfigurationConnector } from './BYRConnectors';
import { logChangeStep } from './analytics';
import { VENTILATION_EXAMPLE_RIDGE_PRODUCTS } from './hardcode';
import { getNextStep, getPrevStep, StepConfiguration } from './steps_order';
import css from './styles_step';
import { If, HeaderIcon, MoveNext, PrevNext, mapBuilderData } from './utilities';
import { PrefixWithLocale } from '../Utilities';
import { connectLocation } from '../location/LocationConnectors';

export const Ventilation = connectLocation(
  ConfigurationConnector(({ t, handlers, state, products, locale, configuration = {} }) => {
    products = Object.fromEntries(
      Object.entries(products || {}).map(([key, value]) => [key, (value || []).map(mapBuilderData)])
    );

    useEffect(() => {
      logChangeStep('ventilation', configuration.slug);
      window.model3d.api.changeStep('ventilation');
    }, []);

    const steps = StepConfiguration();
    const next = getNextStep('ventilation');
    const prev = getPrevStep('ventilation');
    const currentStep = steps.find(s => s.name == 'ventilation');
    const nextStep = steps.find(s => s.name == next);

    const example_ridge_product =
      _.chain(products)
        .get('exhaust_ventilation', [])
        .find(i => VENTILATION_EXAMPLE_RIDGE_PRODUCTS.includes(i.uid))
        .value() || {};

    return (
      <div css={css.step}>
        <div css={css.stepHeadingIntro}>
          <HeaderIcon what="breathe" stepHeading />
          <h1 className="h2 stepHeading">{t('build_your_roof.ventilation')}</h1>

          <p>{t('build_your_roof.ventilation_copy')}</p>
        </div>

        <h2 className="h4 body-font">{t('build_your_roof.ventilation_exhaust')}</h2>

        <p>{t('build_your_roof.ventilation_exhaust_copy')}</p>

        <div css={css.optionsContainer}>
          <h6>{t('build_your_roof.ventilation_cta_heading')}</h6>

          <label className={state.selected_ventilation == 'ridge_vents' ? 'option-selected' : ''}>
            <input
              type="radio"
              name="ventilation"
              checked={state.selected_ventilation == 'ridge_vents'}
              onChange={handlers.set('ventilation', 'ridge_vents')}
              data-track="tool-select"
              data-track-option={t('build_your_roof.ventilation_ridge_vents')}
            />
            {t('build_your_roof.ventilation_ridge_vents')}
          </label>
          <label className={state.selected_ventilation == 'off_ridge_vents' ? 'option-selected' : ''}>
            <input
              type="radio"
              name="ventilation"
              checked={state.selected_ventilation == 'off_ridge_vents'}
              onChange={handlers.set('ventilation', 'off_ridge_vents')}
              data-track="tool-select"
              data-track-option={t('build_your_roof.ventilation_off_ridge_vents')}
            />
            {t('build_your_roof.ventilation_off_ridge_vents')}
          </label>
          <label className={state.selected_ventilation == 'ventilation_not_sure' ? 'option-selected' : ''}>
            <input
              type="radio"
              name="ventilation"
              checked={state.selected_ventilation == 'ventilation_not_sure'}
              onChange={handlers.set('ventilation', 'ventilation_not_sure')}
              data-track="tool-select"
              data-track-option={t('build_your_roof.ventilation_not_sure')}
            />
            {t('build_your_roof.ventilation_not_sure')}
          </label>

          <If condition={state.selected_ventilation == 'ridge_vents'}>
            <div>
              <If condition={!_.isEmpty(example_ridge_product)}>
                <h6 css={{ marginBottom: '5px' }}>{t('build_your_roof.ventilation_recommendation')}</h6>

                <div css={css.active_step_item}>
                  <div css={css.stepItemContent}>
                    <p>
                      <strong>{example_ridge_product.name}</strong>
                    </p>
                    <p>{_.get(example_ridge_product, 'intro_copy.value')}</p>
                  </div>
                </div>
              </If>
            </div>
          </If>

          <If condition={state.selected_ventilation == 'off_ridge_vents'}>
            <div>
              <h6 css={{ marginBottom: '5px' }}>{t('build_your_roof.ventilation_recommendation')}</h6>

              <div css={css.active_step_item}>
                <div css={css.stepItemContent}>
                  <p>
                    <strong>{t('build_your_roof.ventilation_off_ridge_vents_heading')}</strong>
                  </p>
                  <p>{t('build_your_roof.ventilation_off_ridge_vents_description')}</p>
                </div>
              </div>
            </div>
          </If>

          <If condition={state.selected_ventilation == 'ventilation_not_sure'}>
            <div>
              <div css={css.active_step_item}>
                <div css={css.stepItemContent}>
                  <p>{t('build_your_roof.ventilation_not_sure_description1')}</p>
                  <p>{t('build_your_roof.ventilation_not_sure_description2')}</p>
                </div>
              </div>
            </div>
          </If>
        </div>

        <h2 className="h4 body-font">{t('build_your_roof.ventilation_intake')}</h2>
        <p>
          {t('build_your_roof.ventilation_intake_description.copy_1')}
          <a
            href={PrefixWithLocale('/roofing/products/inflow-vent', locale.code)}
            target="_blank"
            data-track="learn-more"
            data-track-destination="VentSure InFlow Intake Vents"
            data-track-element-location="main section text link"
            rel="noreferrer"
          >
            {t('build_your_roof.ventilation_intake_description.link_text')}
          </a>
          {t('build_your_roof.ventilation_intake_description.copy_2')}
        </p>
        <div css={css.ctaContainer}>
          <MoveNext
            next={next}
            data-track="tool-advance"
            className="oc-cta-button"
            css={
              state.selected_ventilation == 'ridge_vents' ||
              state.selected_ventilation == 'off_ridge_vents' ||
              state.selected_ventilation == 'ventilation_not_sure'
                ? ''
                : css.disabled
            }
            styles={css.nextBtn}
          />
          <PrevNext prev={prev} />
        </div>
      </div>
    );
  })
);
